/**
* @name: base-set
* @author: weiyong
* @date: 2023-03-31 20:45
* @description：base-set
* @update: 2023-03-31 20:45
*/
<template>
  <div :class="prefixCls" class="themeAttr-item">
    <span class="themeAttr-item-title">{{t('基础设置')}}</span>
    <div class="themeAttr-item-body w100b flex-div">

      <div class="switch-item">
        <div class="switch-label">{{t('面包屑')}}</div>
        <a-switch @change="(checked)=>{change(HandlerEnum.SHOW_BREADCRUMB,checked)}"  v-model:checked="breadCrumbFlag" />
      </div>

      <div class="switch-item">
        <div class="switch-label">{{t('灰色模式')}}</div>
        <a-switch @change="(checked)=>{change(HandlerEnum.GRAY_MODE,checked)}"  v-model:checked="getGrayModeFlag" />
      </div>

      <div class="switch-item">
        <div class="switch-label">{{t('色弱模式')}}</div>
        <a-switch @change="(checked)=>{change(HandlerEnum.COLOR_WEAK,checked)}"  v-model:checked="getColorWeakFlag" />
      </div>

      <div class="switch-item">
        <div class="switch-label">{{t('快捷菜单')}}</div>
        <a-switch  @change="(checked)=>{change(HandlerEnum.QUICK_MENU_SHOW,checked)}" v-model:checked="getQuickMenuShow"/>
      </div>

      <div class="switch-item">
        <div class="switch-label">{{t('菜单互斥')}}</div>
        <a-switch  @change="(checked)=>{change(HandlerEnum.MENU_OPEN_MORE,checked)}" v-model:checked="getMenuOpenMore"/>
      </div>

      <div class="switch-item">
        <div class="switch-label">{{t('隐藏应用菜单')}}</div>
        <a-switch  @change="(checked)=>{change(HandlerEnum.NOT_SHOW_APP_MENU,checked)}" v-model:checked="notShowAppMenu"/>
      </div>

    </div>
  </div>

  <tab-setting :userSetting="userSetting" :useLayout="useLayout"></tab-setting>

  <header-left-set :userSetting="userSetting" :useLayout="useLayout"/>

  <div :class="prefixCls" class="themeAttr-item" v-if="!userSetting">
    <div class="flex-div-bet">
      <span class="themeAttr-item-title">
      {{t('头部右侧图标设置')}}
    </span>
      <span class="common-link" @click.stop="editorRightTools" style="padding-right: 12px;"> {{!getEditoringFlag?t('编辑'):t('取消编辑')}}</span>
    </div>
    <div class="themeAttr-item-body w100b flex-div">

<!--      <div class="switch-item" >-->
<!--        <div class="switch-label">{{t('动态呼叫')}}</div>-->
<!--        <a-switch @change="(checked)=>{change(HandlerEnum.HEADER_CALLING_SHOW,checked)}"  v-model:checked="getShowCalling" />-->
<!--      </div>-->

      <div class="switch-item" >
        <div class="switch-label">{{t('移动端下载')}}</div>
        <a-switch @change="(checked)=>{change(HandlerEnum.HEADER_SHOW_APP,checked)}"  v-model:checked="getShowApp" />
      </div>

      <div class="switch-item" v-if="!userSetting && !isFrameLayout">
        <div class="switch-label">{{t('查询信息')}}</div>
        <a-switch @change="(checked)=>{change(HandlerEnum.HEADER_SEARCH,checked)}"  v-model:checked="getShowSearch" />
      </div>

      <div class="switch-item" v-if="!userSetting">
        <div class="switch-label">{{t('消息提醒')}}</div>
        <a-switch @change="(checked)=>{change(HandlerEnum.HEADER_NOTICE,checked)}"  v-model:checked="getShowNotice" />
      </div>

      <div class="switch-item" v-if="!userSetting">
        <div class="switch-label">{{t('最大化')}}</div>
        <a-switch @change="(checked)=>{change(HandlerEnum.HEADER_BIG_SCREEN,checked)}"  v-model:checked="getShowFullScreen" />
      </div>

<!--      <div class="switch-item" >-->
<!--        <div class="switch-label">{{t('用户自定义')}}</div>-->
<!--        <a-switch @change="(checked)=>{change(HandlerEnum.USE_DEF_LAYOUT,checked)}"  v-model:checked="userDefLayout" />-->
<!--      </div>-->

      <div class="switch-item" v-if="!userSetting">
        <div class="switch-label">{{t('帮助中心')}}</div>
        <a-switch @change="(checked)=>{change(HandlerEnum.HEADER_HELP_ICON_SCREEN,checked)}"  v-model:checked="getShowHelp" />
      </div>

      <div class="switch-item" v-if="!userSetting">
        <div class="switch-label">{{t('界面缓存')}}</div>
        <a-switch @change="(checked)=>{change(HandlerEnum.HEADER_KEEP_ALIVE,checked)}"  v-model:checked="getOpenKeepAlive" />
      </div>
    </div>

    <div class="sel-icon-color">
      <div>选择图标颜色</div>
      <use-sel-color style="padding-right: 0;width:102px;" @closeOtherColor="closeOtherColor" @selItem="selItem" ref="useSelCtrl"/>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "base-set",
});
</script>

<script lang="ts" setup>
import TabSetting from "@/views/dashboard/analysisSet/components/tab-setting.vue";
import HeaderLeftSet from "@/views/dashboard/analysisSet/components/header-left-set.vue";
import UseSelColor from "@/views/dashboard/analysisSet/components/use-sel-color.vue";
import {Switch as ASwitch} from "ant-design-vue";
import {useDesign} from "@/hooks/web/useDesign";
import {baseHandler} from "@/layouts/default/setting/handler";
import {HandlerEnum} from "@/layouts/default/setting/enum";
import {useRootSetting} from "@/hooks/setting/useRootSetting";
import {useI18n} from "vue-i18n";
import {useHeaderSetting} from "@/hooks/setting/useHeaderSetting";

const { t } = useI18n();


const {
  getNotShowAppMenuFlag,
  getColorWeak,
  getGrayMode,
  getUserDefLayout,
  getShowBreadCrumb,
  getQuickMenuShow,
  getMenuOpenMore,
  getOpenKeepAlive
} = useRootSetting();

const {
  getShowHelp,
  getShowFullScreen,
  getShowNotice,
  getShowSearch,
  getShowApp,
  getShowCalling
} = useHeaderSetting();


const change=function (event,val){
  baseHandler(event, val)
}

//是否可以用户定义布局
const userDefLayout=ref(getUserDefLayout);
const breadCrumbFlag=ref(unref(getShowBreadCrumb));
const getColorWeakFlag=ref(unref(getColorWeak));
const getGrayModeFlag=ref(unref(getGrayMode));
const notShowAppMenu=ref(unref(getNotShowAppMenuFlag));

const {prefixCls} = useDesign('base-set');

interface IProps{
  useLayout:string,
  userSetting:boolean
}
const props=withDefaults(defineProps<IProps>(),{
  userSetting:false,
  useLayout:'defaultFrame'
})

const FRAME_LAYOUTS = ['technology', 'classicBlue'];
const isFrameLayout = computed(() => FRAME_LAYOUTS.includes(props.useLayout));

const emits = defineEmits(['closeOtherColor'])

const closeOtherColor=function (){
  emits('closeOtherColor', {});
}

const selItem = function (item) {
  baseHandler(HandlerEnum.HEADER_ICON_THEME, item.id)
}


const {
  getEditoringFlag,
} = useHeaderSetting();
/**
 * 右侧头部菜单编辑
 */
const editorRightTools=function (){
  let flag:boolean=false;
  unref(getEditoringFlag)===false?flag=true:flag=false;
  baseHandler(HandlerEnum.HEADER_RIGHT_TOOLS_EDITOR,flag)
}

</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-base-set';

.@{prefix-cls} {
  width: 100%;
  padding: 16px;
  margin-bottom: 10px;
  border-radius: 6px;
  background: #fff;
  font-family: PingFangSC-Semibold,PingFang SC;

  .switch-item{
    width:33.33%;
    margin-bottom: 12px;
  }
  .switch-label{
    margin-bottom: 8px;
  }
  .themeAttr-item-body{
    flex-wrap: wrap;
  }
  .themeAttr-item-title {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #111;
    margin-bottom: 14px;
  }
  .itme-title-span{
    text-align: center;
    margin-top: 6px;
  }
  .item-type-sign {
    width: 56px;
    height: 56px;
    padding: 3px;
    border: 1px solid #fff;
    border-radius: 3px;
    margin-right: 12px;
  }
}
.sel-icon-color{
  .color-div{
    height:30px;
    border-radius: 4px;
    cursor:pointer;
  }
  .layoutItem-type-sign-icon{
    display: none;
  }
}
</style>
